
// export const API_HOST = '/api-main/api'
export const UI_HOST = (process.env.NODE_ENV === 'production')
  ? 'https://app.telemedicinamorsch.com.br'
  : 'https://ui.telemedicinamorsch.com.br'

export const MARKETPLACE_HOST = (process.env.NODE_ENV === 'production')
  ? 'https://telemedicinamorsch.com.br'
  : 'https://localhost:8081'

export const API_HOST = (process.env.NODE_ENV === 'production')
  ? '//app.telemedicinamorsch.com.br/api-main/v1'
  : '//ui.telemedicinamorsch.com.br/api-main/v1'

export const API_AUTH = (process.env.NODE_ENV === 'production')
  ? '//app.telemedicinamorsch.com.br/api-auth/v1'
  : '//ui.telemedicinamorsch.com.br/api-auth/v1'

export const SERVICE_CHAT = (process.env.NODE_ENV === 'production')
  ? '//app.telemedicinamorsch.com.br/service-chat/v1'
  : '//ui.telemedicinamorsch.com.br/service-chat/v1'

  export const API_MEMED = (process.env.NODE_ENV === 'production')
  ? 'https://api.memed.com.br'
  : 'https://api.memed.com.br' // homologação: 'https://integrations.api.memed.com.br'

export const MEMED = (process.env.NODE_ENV === 'production')
  ? 'https://memed.com.br'
  : 'https://memed.com.br' // homologação: 'https://integrations.memed.com.br'

// Script do iframe de prescrição. Homologação exige par de chaves de sandbox,
// por isso o default também aponta para produção.
export const MEMED_SCRIPT = process.env.REACT_APP_MEMED_SCRIPT_URL ||
  'https://partners.memed.com.br/integration.js'
  // homologação: 'https://integrations.memed.com.br/modulos/plataforma.sinapse-prescricao/build/sinapse-prescricao.min.js'
